import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./components/auth/Login/Login";
import Fxbazzar from "./views/layout/Fxbazzar";
import PrivacyPolicyPage from "./components/legal/PrivacyPolicyPage";
import { setAuthToken } from "./utils/api";
import { isTokenExpired } from "./utils/auth";
import { FONT_ROBOTO } from "./utils/fonts";
import { useBrokerTimeZoneId } from "./utils/dateFormats";
import { loadBrokerTimeZoneFromApi } from "./utils/loadBrokerTimeZone";
import { store } from "./Store/appStore";
import { clearSegmentsList } from "./Store/Reducer/common.slice";

function AuthRoute({ storageKey, isAdminLogin }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user,       setUser]       = useState(null);
  const [checking,   setChecking]   = useState(true);
  useBrokerTimeZoneId();

  
  useEffect(() => {
    const boot = async () => {
      loadBrokerTimeZoneFromApi().catch(() => {});

      const stored = sessionStorage.getItem(storageKey);
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          if (!isTokenExpired(parsed.token, { authViaCookies: parsed.authViaCookies })) {
            setUser(parsed);
            setAuthToken(parsed.token);
            setIsLoggedIn(true);
          } else {
            sessionStorage.removeItem(storageKey);
          }
        } catch {
          sessionStorage.removeItem(storageKey);
        }
      }
      setChecking(false);
    };
    boot();
  }, [storageKey]);

  
  const handleLogin = async (userData) => {
    const viaCookies = Boolean(userData?.authViaCookies);
    if (!userData?.token && !viaCookies) return;

    store.dispatch(clearSegmentsList());
    setAuthToken(userData.token || null);

    
    const stored = sessionStorage.getItem(storageKey);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setUser(parsed);
      } catch {
        setUser(userData); // fallback
      }
    } else {
      setUser(userData);
    }

    loadBrokerTimeZoneFromApi().catch(() => {});
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    store.dispatch(clearSegmentsList());
    sessionStorage.removeItem(storageKey);
    // Prevent stale mode/token from overriding fresh fxbazzar_* login session.
    sessionStorage.removeItem("TradeSession");
    setUser(null);
    setAuthToken(null);
    setIsLoggedIn(false);
  };

  if (checking) return (
    <div style={{
      display:'flex', alignItems:'center', justifyContent:'center',
      height:'100vh', background:'#1a0a0a', color:'#4caf7d',
      fontFamily: FONT_ROBOTO, fontSize:14, letterSpacing:1,
    }}>
      Loading…
    </div>
  );

  return isLoggedIn
    ? <Fxbazzar user={user} onLogout={handleLogout} />
    : <Login onLogin={handleLogin} isAdminLogin={isAdminLogin} />;
}

const App = () => (
  <Routes>
    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
    <Route path="/"      element={<AuthRoute storageKey="fxbazzar_user"  isAdminLogin={false} />} />
    <Route path="/admin" element={<AuthRoute storageKey="fxbazzar_admin" isAdminLogin={true}  />} />
    <Route path="*"      element={<AuthRoute storageKey="fxbazzar_user"  isAdminLogin={false} />} />
  </Routes>
);

export default App;